import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

const state = {
  promiseBtn: ["video", "add"],
  nav: [],
  isdark: true,
  isFullScreen: false,
  carMsg: {
    carNo: "",
    play: 1
  },
  control: false,
  menu: {
    //菜单状态
    status: false //false--展开 true--缩进
  },
  topMenuList: [{ name: "工作台", link: "/control", now: 0, id: 0 }],
  nowActiveTitle: "",
  csr: {},
  dots: {},
  bendi: {
    name: "广州喜洋智慧物流管理系统",
    extend: "2222222",
    mainLogoPic: "static/logo/ly1.png",
    linkLogoPic: "static/logo/xy.png",
    loginBgPic: "static/login/ly.jpg",
    footerEnabled: true,
    footerLink: "",
    footerTitle: "", //beian
    linkTitle: "555555",
    mainTitle: "",
    remark: "7777777",
    bgColor: "#f5f5f5",
    themeName: "black",
    fontColor: "#fff",
    themeColor: "#333",
    aidColor: "#0bbf11",
    adornColor: "#388ded",
    otherColor: "#e9f1f7",
    company: "喜洋物流",
    qrCodeList: [
       {
      qrCodePic: 'static/e/waibucheliang.png',
      qrCodeTitle: "外部车辆接入",
      qrCodeDes: "提供给外部车辆录入系统使用",
    }, {
      qrCodePic: 'static/e/kehuduan.png',
      qrCodeTitle: "客户端",
      qrCodeDes: "客户可以查看物流信息，订单信息",
    } 
    ]
  },
  inCss(data) {
    return;
    var rootcss = document.getElementById("rootcss");
    rootcss.innerHTML = ":root {--loginColor:" + data.adornColor + ";}";
  }
};
var tmplId = getUrlKey("t");
if (tmplId == null) {
  state.csr = state.bendi;
  state.inCss(state.csr);
  document.getElementById("webTitle").innerHTML = state.csr.name;
  document.getElementById("webPhoto").href = "static/logo/ly1.png";
} else {
  setTimeout(() => {
    gettmpl();
  }, 200);
}

function gettmpl() {
  let params = {
    id: tmplId
  };
  axios({
    method: "post",
    url: "/tmpl/item",
    data: params
  }).then(res => {
    state.csr = res.data.data;
    state.inCss(res.data.data);
    document.getElementById("webTitle").innerHTML = state.csr.name;
    document.getElementById("webPhoto").href = state.csr.smallLogo
      ? state.csr.smallLogo
      : "static/logo/defaul.png";
  });
}
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

setTimeout(() => {
  //getdic();
}, 500);

export default new Vuex.Store({
  state
});



// WEBPACK FOOTER //
// ./src/vuex/store.js